import React from 'react'
import Gobackimage from "./goback.png"


export default function Goback() {
  return (
    <img src={Gobackimage} width="25px" height="25px"></img>
  )
}


